import React, { useRef, useEffect, useState } from "react";

const DynamicTextScale = ({ filteredIndo, inx, szrgrp, valueBasedOnInx, referance, brand, category, subCategory }) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [gap, setGap] = useState("5px");
  const [marginLeft, setMarginLeft] = useState("0px");
  const [scaleReady, setScaleReady] = useState(false); // opacity için

  const data = [
    { value: 203, result: 5 },
    { value: 161, result: 17 },
    { value: 123, result: 20 },
  ];

  const adjustScale = () => {
    const mmToPx = (mm) => mm * 3.779528;
    const targetWidthPx = mmToPx(37.213);

    if (containerRef.current && contentRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const contentWidth = contentRef.current.scrollWidth;

      requestAnimationFrame(() => {
        if (containerWidth > 140) {
          const excessWidth = containerWidth - 140;
          const scaleFactor = (containerWidth - excessWidth) / containerWidth;
          setScale(scaleFactor);
        } else if (contentWidth > containerWidth) {
          setScale(containerWidth / contentWidth);
        } else {
          setScale(1);
        }

        // Gap ve margin ayarla
        const name = filteredIndo[inx]?.name;
        if (name === "S") {
          setGap("8px");
          setMarginLeft("10px");
        } else if (name === "M") {
          setGap("6px");
          setMarginLeft("6px");
        } else if (name === "L") {
          setGap("9px");
          setMarginLeft("13px");
        }

        setScaleReady(true); // opacity aç
      });
    }
  };

  useEffect(() => {
    // İlk yüklemede
    const timeout = setTimeout(() => {
      adjustScale();
    }, 50);

    // Resize için dinleme
    window.addEventListener("resize", adjustScale);

    // ResizeObserver ile içerik değişimi dinleme
    const observer = new ResizeObserver(() => {
      adjustScale();
    });
    if (containerRef.current) observer.observe(containerRef.current);

    return () => {
      window.removeEventListener("resize", adjustScale);
      clearTimeout(timeout);
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, [filteredIndo, inx]);

  return (
    <div
      style={{
        position: "relative",
        top: 108,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        margin: "0 auto",
      }}
    >
      <div
        ref={containerRef}
        style={{
          position: "relative",
          overflow: "hidden",
          maxWidth: "37.1mm",
          display: "flex",
          margin: "0 auto",
          transform: "translateX(6px)",
        }}
      >
        <div
          ref={contentRef}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "nowrap",
            transform: `scaleX(${scale})`,
            transformOrigin: "left",
            transition: "transform 0.3s ease",
            opacity: scaleReady ? 1 : 0,
            transitionProperty: "transform, opacity",
          }}
        >
          <p
            className="helve-medium"
            style={{
              fontSize: "24pt",
              margin: "0",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              marginRight: 6,
              marginLeft: marginLeft,
            }}
          >
            {filteredIndo[inx]?.name || "N/A"}
          </p>

          <div
            style={{
              display: "flex",
              whiteSpace: "nowrap",
              overflow: "hidden",
              gap: gap,
            }}
          >
            {[
              { label: "", value: szrgrp.sizes[valueBasedOnInx].usa },
              { label: "", value: szrgrp.sizes[valueBasedOnInx].mexico },
              { label: "", value: szrgrp.sizes[valueBasedOnInx].uk },
              { label: "", value: szrgrp.sizes[valueBasedOnInx].ita },
              { label: "", value: szrgrp.sizes[valueBasedOnInx].brBrasil },
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
              >
                <p
                  className="helve-roman"
                  style={{
                    fontSize: "5pt",
                    marginTop: "12px",
                  }}
                >
                  {item.label}
                </p>
                <p
                  className="helve-medium"
                  style={{
                    fontSize: "12pt",
                    marginTop: "-3px",
                    margin: "0",
                  }}
                >
                  {item.value}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DynamicTextScale;
